var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLudeng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12H8.5L9 16H7L7.5 12Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 10.6667 8 7.4 8 5C8 2.6 10 1.5 11 1.5",
    stroke: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 10.6667 8 7.4 8 5C8 2.6 6 1.5 5 1.5",
    stroke: "#595959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1H14.5V2H11V1Z",
    fill: "#595959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1H5V2H1.5V1Z",
    fill: "#595959"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3L1 4.5",
    stroke: "#595959",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3L11 4.5",
    stroke: "#595959",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V5",
    stroke: "#595959",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3V5",
    stroke: "#595959",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3L5 4.5",
    stroke: "#595959",
    strokeWidth: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3L15 4.5",
    stroke: "#595959",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudeng);
export default __webpack_public_path__ + "static/media/ludeng.961c53bae6e72d45639021560b9220cd.svg";
export { ForwardRef as ReactComponent };